import { ReactNode } from 'react';
import styled from '@emotion/styled';

interface ItemCardPriceSectionProps {
  children: ReactNode;
}

export const ItemCardPriceSection = ({ children }: ItemCardPriceSectionProps) => {
  return <PriceSection>{children}</PriceSection>;
};

const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
`;
